import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=8a73dbb0&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=8a73dbb0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a73dbb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a73dbb0')) {
      api.createRecord('8a73dbb0', component.options)
    } else {
      api.reload('8a73dbb0', component.options)
    }
    module.hot.accept("./orderDetail.vue?vue&type=template&id=8a73dbb0&scoped=true", function () {
      api.rerender('8a73dbb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rsManagement/expressOrderList/components/orderDetail.vue"
export default component.exports